import { FeatureFlag } from '@/types/featureFlags';
import {
  postOrganizationSubscriptionFunction,
} from '@/services/supabase/registryFunctionClient';

type FeatureFlagsEdgeResponse = {
  featureFlags: Array<{
    id: string;
    featureName: string;
    isEnabled: boolean;
    isPaid: boolean;
    planName?: string | null;
    createdAt: string;
    updatedAt: string;
  }>;
};

export class FeatureFlagsService {
  static async getAllFeatureFlags(organizationSlug: string): Promise<FeatureFlag[]> {
    const data = await postOrganizationSubscriptionFunction<FeatureFlagsEdgeResponse>(
      {
        organizationSlug: organizationSlug.trim(),
        query: 'feature_flags',
      },
    );

    return (data.featureFlags ?? []).map((flag) => ({
      id: flag.id,
      featureName: flag.featureName,
      isEnabled: flag.isEnabled,
      isPaid: flag.isPaid,
      planName: flag.planName,
      createdAt: new Date(flag.createdAt),
      updatedAt: new Date(flag.updatedAt),
    }));
  }
}
